/**
 * Type guard to filter out null and undefined values from an array
 * Returns a new array with the non-null values typed correctly
 */
export function notNull<T>(value: T | null | undefined): value is T {
  return value != null
}
